var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#FFC726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H171V341.994H0V-0.00585938ZM342 -0.00585938H513V341.994H342V-0.00585938Z",
    fill: "#00267F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.74 101.014L293.77 113.414C293.09 114.764 287.98 120.954 285.59 166.474H268.54V106.054L256 78.6742L243.46 105.674V166.474H226.4C224.01 120.944 218.6 113.994 217.93 112.634L186.25 101.004C186.4 101.314 201.65 132.344 201.65 179.014V191.554H243.46V262.624H268.54V191.554H310.35V179.014C310.35 154.884 314.52 134.994 318.03 122.554C321.85 108.984 325.73 101.064 325.77 100.984L325.74 101.014Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/BB.59c833d9c2faba3ba01d34be6f7113ac.svg";
export { ForwardRef as ReactComponent };